// browser-sync start --server

import Konva from 'goog:module$node_modules$konva$lib$Core';

let darkMode = document.body.getAttribute("dark") == "true";

function darkModeOption(normal, dark) {
  if (darkMode) {
    return dark;
  } else {
    return normal;
  }
}

function debounce(callback, wait, immediate) {
  var timeout;
  return function () {
    var context = this, args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) callback.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) callback.apply(context, args);
  };
};

// Use center-center distance check for non-rotated rects.
function hasOverlap(r1, r2) {

  let w1 = r1.width, h1 = r1.height;
  let w2 = r2.width, h2 = r2.height;

  let diff = {
    x: Math.abs((r1.x + w1 / 2) - (r2.x + w2 / 2)),
    y: Math.abs((r1.y + h1 / 2) - (r2.y + h2 / 2))
  };

  let compWidth = (r1.width + r2.width) / 2,
    compHeight = (r1.height + r2.height) / 2;

  let hasOverlap = ((diff.x <= compWidth) && (diff.y <= compHeight))

  return hasOverlap;
}

function statusColor(status) {
  let colors = {
    "completed": "#8ABB80",
    "succeeded": "#8ABB80",
    "failed": "#F5564A",
    "pending": "#b09861",
    "running": "#FFB020",
  };

  let fallbackColor = "#828E95";

  return colors[status] || fallbackColor;
}

function deepEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    const areFunctions = isFunction(val1) && isFunction(val2);
    if (
      areObjects && !deepEqual(val1, val2) ||
      !areObjects && !areFunctions && val1 !== val2
    ) {
      return false;
    }
  }
  return true;
}
function isObject(object) {
  return object != null && typeof object === 'object';
}

function isFunction(object) {
  return typeof object === 'function';
}

let dagCache = {};

// Konva.pixelRatio = 2


function clipFunc(p) {
  let y = p.y;
  let radius = p.radius;
  let x = p.x;
  let height = p.height;
  let width = p.width;

  return function (ctx) {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
  }
}

function clipRightFunc(p) {
  let x = p.x || 0;
  let y = p.y || 0;

  let radius = p.radius || 4;
  let height = p.height || 100;
  let width = p.width || 100;

  return function (ctx) {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width, y);
    ctx.lineTo(x + width, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
  };
}

let transformIcon = new Image();
transformIcon.src = "/img/dag/transform.png"

let extractIcon = new Image();
extractIcon.src = "/img/dag/extract.png";

const nodeWidth = 400;
const nodeHeight = 130;
const nodeTextWidth = 120;


function extractStatus(status) {
  const statusMapping = {
    "running": "pending",
    "success": "succeeded",
    "fail": "failed",
  };

  return statusMapping[status] || status;
}


function selectNode(node) {
  node.draggable(true);
  node.clearCache();
  node.findOne('.outer-layout').stroke("#55ABDE");
}


function deSelectNode(node) {
  node.draggable(false);
  node.findOne('.outer-layout').stroke("#CFD5DD");
  node.cache();
}


// Returns a fully rendered DAG node
function DAGnode(props) {
  let node = new Konva.Group({
    x: props.x || 0,
    y: props.y || 0,
    name: "node " + "node-group-" + props.node["group-id"],
    id: props.id,
    draggable: false,
    transformsEnabled: "position",
    perfectDrawEnabled: false,
  });

  node.on('contextmenu', (e) => {
    e.evt.preventDefault();
  });

  node.on('click', function (e) {
    e.evt.preventDefault();
    e.cancelBubble = true

    if (e.evt.button === 2) {
      if (props.node["on-node-right-click"]) {
        props.node["on-node-right-click"](e);
      }
    }
  })

  node.on('dblclick', function (e) {
    selectNode(node);
  });

  node.on('dragend', function (e) {
    deSelectNode(node);
    updateConnections(node);
    updateGroupPosition(node, true);
  })

  node.on('dragmove', function (e) {
    updateConnections(node);
    // Need to disable it for consistent speed.
    // Works really well on smaller dags.
    // updateGroupPosition(node);
  })

  node.on('mouseenter', function (e) {
    if (props.node["on-node-mouseenter"]) {
      props.node["on-node-mouseenter"](e);
    }

    highlightConnectedEdges(node);
  })

  node.on('mouseleave', function (e) {
    if (props.node["on-node-mouseleave"]) {
      props.node["on-node-mouseleave"](e);
    }

    unHighlightConnectedEdges(node);
  })

  let outerLayout = new Konva.Rect({
    width: nodeWidth,
    height: nodeHeight,
    stroke: "#CFD5DD",
    cornerRadius: 12,
    transformsEnabled: "position",
    perfectDrawEnabled: false,
    // listening: false,
    name: "outer-layout",
  });

  let outerLayoutFiller = new Konva.Rect({
    x: 1,
    y: 1,
    width: nodeWidth - 2,
    height: nodeHeight - 2,
    fill: "#FFFFFF",
    cornerRadius: 12,
    transformsEnabled: "position",
    perfectDrawEnabled: false,
    listening: false,
  });

  let fullViewNode = new Konva.Group({
    listening: false,
    transformsEnabled: "position",
    perfectDrawEnabled: false,
  });


  // colored sidebar
  let sidebarGroup = new Konva.Group({
    clipFunc: clipRightFunc({ width: 11, height: nodeHeight, radius: 16 }),
  });

  let nodeType = props.node.type;

  let transformStatus;
  let executionStatus;

  let statusString;

  if (nodeType == "extract") {
    transformStatus = extractStatus(props.node["extract"]["last-run-status"]);
    executionStatus = {
      "last-run-at": props.node["extract"]["last-run-at"],
      "status": transformStatus,
    }
  } else {
    transformStatus = props.node.transform?.status;

    executionStatus = props.props["statuses"]?.find(n => {
      return n["transform-id"] === props.node?.transform["transform-id"]
    });
  }

  statusString = props.node["format-status"](executionStatus, transformStatus);

  let color = statusColor(executionStatus?.["is-executing"] ? "running" : executionStatus?.status);

  let statusOuterLayoutFiller = new Konva.Rect({
    visible: false,
    name: "node-status-filler",
    x: 1,
    y: 1,
    width: nodeWidth - 2,
    height: nodeHeight - 2,
    fill: color,
    cornerRadius: 12,
    transformsEnabled: "position",
    perfectDrawEnabled: false,
    listening: false,
  });


  let sidebarElem = new Konva.Rect({
    width: 11,
    height: nodeHeight,
    x: 1,
    y: 1,
    fill: color,
    transformsEnabled: "position",
    perfectDrawEnabled: false,
    listening: false,
  });

  sidebarGroup.add(sidebarElem);

  // Details
  let nodeDetailsGroup = new Konva.Group({
    x: 11,
    y: 0,
    transformsEnabled: "position",
    perfectDrawEnabled: false,
    listening: false,
    name: "zoomed-in",
  });


  let nodeStatus = new Konva.Text({
    x: 12,
    y: 10,
    fill: color,
    fontSize: 13,
    fontStyle: 600,
    ellipsis: true,
    wrap: "char",
    width: nodeWidth - 20 - 10,
    height: 20,
    text: statusString,
    transformsEnabled: "position",
    perfectDrawEnabled: false,
    listening: false,
  });

  nodeDetailsGroup.add(nodeStatus);

  let nodeTypeText = new Konva.Text({
    x: -15,
    y: 10,
    fill: "grey",
    fontSize: 13,
    fontStyle: 600,
    ellipsis: true,
    wrap: "char",
    width: nodeWidth - 20 - 10,
    height: 20,
    align: "right",
    text: nodeType == "transform" ? "Transform" : "Extract",
    transformsEnabled: "position",
    perfectDrawEnabled: false,
    listening: false,
  })

  nodeDetailsGroup.add(nodeTypeText);

  let nodeIcon = new Konva.Image({
    x: nodeWidth - 40,
    y: 6,
    width: 20,
    height: 20,
    align: "right",
    image: nodeType == "transform" ? transformIcon : extractIcon,
    transformsEnabled: "position",
    perfectDrawEnabled: false,
    listening: false,
  })

  nodeDetailsGroup.add(nodeIcon);

  let separator = new Konva.Rect({
    x: 0,
    y: 30,
    fill: "#CFD5DD",
    height: 1,
    width: nodeWidth - 11,
    transformsEnabled: "position",
    perfectDrawEnabled: false,
    listening: false,
  })

  nodeDetailsGroup.add(separator);

  let nodeTitle = new Konva.Text({
    text: props.name,
    x: 12,
    y: 43,
    fontSize: 16,
    width: nodeWidth - 11 - 12 - 10,
    lineHeight: 1.25,
    align: "left",
    wrap: "char",
    fill: "black",
    transformsEnabled: "position",
    perfectDrawEnabled: false,
    listening: false,
  })

  nodeDetailsGroup.add(nodeTitle);

  fullViewNode.add(sidebarGroup);
  fullViewNode.add(nodeDetailsGroup);

  node.add(outerLayout)
  node.add(outerLayoutFiller);
  node.add(fullViewNode);
  node.add(statusOuterLayoutFiller);

  return node;
}

const groupPadding = 30;

const groupColors = {
  transformsBackground: "#F3F2F8",
  transformsDarkBackgorund: "#F3F2F8",

  transformsStroke: "#E4E4E7",

  extracctsBackground: "#1A0F62",
  extractsDarkBackground: "#463b5c",

  extractsStroke: "#0e0836",

  selectedStroke: "#55ABDE",
};

function calculateBoundingRect(nodes) {
  let startX = 0;
  let endX = 0;
  let startY = 0;
  let endY = 0;

  let firstNode = nodes[0];

  startX = firstNode.x();
  endX = startX;
  startY = firstNode.y();
  endY = startY;

  nodes.map(node => {
    let x = node.x();
    let y = node.y();

    if (x < startX) {
      startX = x;
    }

    if (x > startX && x > endX) {
      endX = x;
    }

    if (y < startY) {
      startY = y;
    }

    if (y > startY && y > endY) {
      endY = y;
    }
  });


  return { startX, startY, endX, endY };
}

function addGroupPadding(coords) {
  let { startX, startY, endX, endY } = coords;

  const padding = 30;
  const titleOffset = 36 + 24;

  startX = startX - padding;
  startY = startY - (padding + titleOffset);
  endX = endX + nodeWidth + padding;
  endY = endY + nodeHeight + padding + padding;

  return { startX, startY, endX, endY };
}

function calculateSize(coords) {
  let { startX, startY, endX, endY } = coords;

  let width = endX - startX;
  let height = endY - startY;

  return { height, width };
}

const liveUpdateGroupSizeLimit = 25;

function updateGroupPosition(node, forceUpdate) {
  let stage = node.getStage();
  let id = node.id();

  let nodeIdPrefix = "node-group-";

  let groupId = node.name().split(" ").find(name => name.startsWith(nodeIdPrefix)).replace(nodeIdPrefix, "");

  let nodesWithinTheGroup = stage.find('.' + nodeIdPrefix + groupId);

  if (nodesWithinTheGroup.length > liveUpdateGroupSizeLimit
    && !forceUpdate) {
    return;
  }

  let coords = calculateBoundingRect(nodesWithinTheGroup);
  let coordsWithPadding = addGroupPadding(coords);
  let size = calculateSize(coordsWithPadding);

  let group = stage.findOne("#" + groupId);
  let groupContainer = group.findOne(".nodes-group-container");

  let groupX = group.x();
  let groupY = group.y();

  let groupHeight = groupContainer.height();
  let groupWidth = groupContainer.width();

  let sameOrigin = groupX == coordsWithPadding.startX && groupY == coordsWithPadding.startY;
  let sameSize = groupHeight == size.height && groupWidth == size.width;

  if (sameOrigin && sameSize) {
    return group;
  }

  if (!sameOrigin) {
    group.setAttrs({
      x: coordsWithPadding.startX,
      y: coordsWithPadding.startY,
    });
  }

  if (!sameSize) {
    groupContainer.setAttrs({
      height: size.height,
      width: size.width,
    });

    group.cache();
  }

  return group;
}

let groupDragPositionCache = {};

function selectGroupNode(node) {
  node.draggable(true);
  node.clearCache();
  node.findOne('.nodes-group-container').stroke(groupColors.selectedStroke);
}

function updatePositionOfNodesWithinTheGroup(node, offset) {
  let stage = node.getStage();
  let id = node.id();

  let nodeIdPrefix = "node-group-";

  let nodesWithinTheGroup = stage.find('.' + nodeIdPrefix + id);

  nodesWithinTheGroup.map(dagNode => {
    let x = dagNode.x();
    let y = dagNode.y();

    dagNode.setAttrs({
      x: x - offset.x,
      y: y - offset.y,
    });

    updateConnections(dagNode);

  });
}

function deSelectGroupNode(node, props) {
  node.draggable(false);

  node.findOne('.nodes-group-container')
    .stroke(props.transformGroup ? groupColors.transformsStroke : groupColors.extractsStroke);

  let x = node.x();
  let y = node.y();
  let id = node.id();

  let oldPosition = groupDragPositionCache[id];

  let diffX = oldPosition.x - x;
  let diffY = oldPosition.y - y;

  updatePositionOfNodesWithinTheGroup(node, { x: diffX, y: diffY });

  node.cache();
}


// Renders a group
function Group(props, stage) {
  let scale = stage.scale().x;

  let textScale = Math.min(2, scale < 1 ? 1 : (1 / scale));

  let groupNode = new Konva.Group({
    x: props.x,
    y: props.y,
    id: props.id,
    name: "nodes-group",
    draggable: false,
  })


  groupNode.on('dblclick', function (e) {
    selectGroupNode(groupNode);
  });

  groupNode.on('click', function (e) {
    e.evt.preventDefault();
    e.cancelBubble = true

    if (e.evt.button === 2) {
      if (props["on-right-click"]) {
        props["on-right-click"](e);
      }
    }
  });

  groupNode.on('dragstart', function (e) {
    let x = groupNode.x();
    let y = groupNode.y();
    let id = groupNode.id();

    groupDragPositionCache[id] = { x, y };
  });

  groupNode.on('dragend', function (e) {
    deSelectGroupNode(groupNode, props);
  })

  let groupRect = new Konva.Rect({
    width: props.width,
    height: props.height,
    opacity: 1,
    cornerRadius: 12,
    fill: props.transformGroup ? groupColors.transformsBackground : darkModeOption(groupColors.extractsDarkBackground, groupColors.extractsDarkBackground),
    stroke: props.transformGroup ? groupColors.transformsStroke : groupColors.extractsStroke,
    name: "nodes-group-container",
  });

  groupNode.add(groupRect);

  let groupTitle = new Konva.Text({
    text: props.name,
    name: "nodes-group-title",
    fontSize: 24 * textScale,
    offsetY: -36 / textScale,
    offsetX: -30,
    fontStyle: 600,
    ellipsis: true,
    wrap: "char",
    width: props.width - 30,
    height: 20,
    align: "left",
    fill: props.transformGroup ? "#000" : "#fff",
    listening: false,
  });

  groupNode.add(groupTitle);

  // groupNode.cache();

  return groupNode;

}



// Calculates the coordinates of the middle point between the two points
function addMidPoint(sx, sy, ex, ey) {
  var lenX = Math.abs(ex - sx);
  var lenY = Math.abs(ey - sy);
  var coefX = 0.3;
  var coefY = 0.1;
  var offsetXLen = Math.max(lenX * coefX, 50);
  var offsetYLen = lenY * coefY;
  var leftOffsetYLen = Math.max(offsetYLen, 50);
  var isRight = sx < ex;
  var isLeft = sx >= ex;
  var isUp = sy > ey;
  var isDown = sy <= ey;
  var centerPoints = [];

  if (isRight && isUp) {
    centerPoints = [sx + offsetXLen, sy - offsetYLen, ex - offsetXLen, ey + offsetYLen];
  }

  if (isRight && isDown) {
    centerPoints = [sx + offsetXLen, sy + offsetYLen, ex - offsetXLen, ey - offsetYLen];
  }

  if (isLeft && isUp) {
    centerPoints = [sx + offsetXLen, sy - leftOffsetYLen, ex - offsetXLen, ey + leftOffsetYLen];
  }

  if (isLeft && isDown) {
    centerPoints = [sx + offsetXLen, sy + leftOffsetYLen, ex - offsetXLen, ey - leftOffsetYLen];
  }

  return [sx, sy].concat(centerPoints).concat([ex, ey]);
}

const edgeStrokes = {
  default: "#CFD5DD",
  highlighted: "#362D76",
  highlightedDark: "#6BFFA8",
  inCycle: "#FF0000",
};

function updateConnections(node) {
  let stage = node.getStage();
  let id = node.id();

  let edgesStartingFromNode = stage.find('.edge-start-' + id);
  let edgesEndingAtNode = stage.find('.edge-end-' + id);

  edgesStartingFromNode.map(edge => {
    let oldPoints = edge.points();
    let [endX, endY] = oldPoints.slice(-2);
    let startX = node.x() + nodeWidth;
    let startY = node.y() + nodeHeight / 2;

    let points = addMidPoint(startX, startY, endX, endY);

    edge.points(points);
  })

  edgesEndingAtNode.map(edge => {
    let oldPoints = edge.points();
    let [startX, startY] = oldPoints.slice(0, 2);
    let endX = node.x();
    let endY = node.y() + nodeHeight / 2;

    let points = addMidPoint(startX, startY, endX, endY);

    edge.points(points);
  })
}


function highlightConnectedEdges(node) {
  let stage = node.getStage();
  let id = node.id();

  let edgesStartingFromNode = stage.find('.edge-start-' + id);
  let edgesEndingAtNode = stage.find('.edge-end-' + id);

  edgesStartingFromNode.map(edge => {
    edge.stroke(darkModeOption(edgeStrokes.highlighted, edgeStrokes.highlightedDark));
  })

  edgesEndingAtNode.map(edge => {
    edge.stroke(darkModeOption(edgeStrokes.highlighted, edgeStrokes.highlightedDark));
  })
}


function unHighlightConnectedEdges(node) {
  let stage = node.getStage();
  let id = node.id();

  let edgesStartingFromNode = stage.find('.edge-start-' + id);
  let edgesEndingAtNode = stage.find('.edge-end-' + id);

  edgesStartingFromNode.map(edge => {
    edge.stroke(edge.attrs.initialStroke);
  })

  edgesEndingAtNode.map(edge => {
    edge.stroke(edge.attrs.initialStroke);
  })
}


// Renders the connection
function Connection(props) {

  let connectionParams = {
    id: props.id,
    name: "edge " + "edge-start-" + props.start.id + " edge-end-" + props.end.id,
    bezier: true,
    // points: [props.start.x, props.start.y, props.end.x, props.end.y],
    points: addMidPoint(props.start.x, props.start.y, props.end.x, props.end.y),
    initialStroke: props.inCycle ? edgeStrokes.inCycle : edgeStrokes.default,
    stroke: props.inCycle ? edgeStrokes.inCycle : edgeStrokes.default,
    strokeWidth: 10,
    hitStrokeWidth: 10,
    perfectDrawEnabled: false,
    transformsEnabled: "position",
  };

  let connection = new Konva.Line(connectionParams);

  // connection.cache();

  return connection;
}

function performViewOptimisation(stage) {
  // Requires further investiogation. From my testing, it actually reduces the
  // rendering speed.
  return;
  let viewPort = { x: 0, y: 0, width: stage.width(), height: stage.height() };

  stage.find('.node').map(n => {
    let overlapped = hasOverlap(viewPort, n.getClientRect());
    if (overlapped) {
      n.show();
    } else {
      n.hide();
    }
  })
}

function updateGroupTitlesFontSizeSlow(stage) {
  let scale = stage.scale().x;

  let textScale = Math.min(2, scale >= 1 ? 1 : (1 / scale));

  let groupTitles = stage.find(".nodes-group-title");

  groupTitles.map(title => {
    title.setAttrs({
      fontSize: 24 * textScale,
      offsetY: -40 / textScale,
    })
  });
}

// Not sure if spawning thousands of timeouts is the best approach here. Maybe
// there is a more appropriate way of doing it with a queue or something.

function pmap(arr, fn) {
  arr.map(el => setTimeout(() => fn(el), 0));
}

function updateNodeStatusDisplayZoomSlow(stage) {
  let scale = stage.scale().x;

  // A canary node to estimate the status of all other nodes
  let canary = stage.findOne(".node-status-filler");

  if (!canary) {
    return;
  }

  if (scale > 0.2) {
    if (!canary.visible()) {
      return;
    }
  } else {
    if (canary.visible()) {
      return;
    }
  }

  pmap(stage.find('.node'), node => {
    if (scale > 0.2) {
      node.findOne(".node-status-filler").hide();
    } else {
      node.findOne(".node-status-filler").show();
    }

    node.clearCache();
    node.cache();
  })
}

let updateGroupTitlesFontSize = debounce(updateGroupTitlesFontSizeSlow, 100);
let updateNodeStatusDisplayZoom = debounce(updateNodeStatusDisplayZoomSlow, 100);

function performZoomOptimisation(stage) {
  return;
  var scale = stage.scaleX();

  stage.find('.node').map(node => {
    if (node.isVisible()) {
      if (scale < 0.4) {
        node.find('.zoomed-in').map(el => el.hide());
      } else {
        node.find('.zoomed-in').map(el => el.show());
      }

      node.clearCache();
      node.cache();
    }
  })

}


// Initial DAG rendering
function dag(containerId, props) {

  var wrapper = document.getElementById(containerId).getBoundingClientRect();
  var width = wrapper.width;
  var height = wrapper.height;

  // first we need to create a stage
  var stage = new Konva.Stage({
    container: containerId,   // id of container <div>
    width: width,
    height: height,
    draggable: true,
    scale: { x: 0.5, y: 0.5 },
    offset: { x: -200, y: -200 },
    fill: "grey"
  });

  var scaleBy = 1.025;

  const scrollZoomHandler = (e) => {
    // stop default scrolling
    e.evt.preventDefault();

    var oldScale = stage.scaleX();
    var pointer = stage.getPointerPosition();

    var mousePointTo = {
      x: (pointer.x - stage.x()) / oldScale,
      y: (pointer.y - stage.y()) / oldScale,
    };

    // how to scale? Zoom in? Or zoom out?
    let direction = e.evt.deltaY < 0 ? 1 : -1;

    // when we zoom on trackpad, e.evt.ctrlKey is true
    // in that case lets revert direction
    // if (e.evt.ctrlKey) {
    //   direction = -direction;
    // }

    var newScale = direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;

    if (newScale > 2.2 || newScale < 0.02) {
      return 0;
    }

    stage.scale({ x: newScale, y: newScale });
    // stage.to({
    //   duration: 0.1,
    //   scaleX: newScale,
    //   scaleY: newScale,
    //   x: pointer.x - mousePointTo.x * newScale,
    //   y: pointer.y - mousePointTo.y * newScale,
    // })

    var newPos = {
      x: pointer.x - mousePointTo.x * newScale,
      y: pointer.y - mousePointTo.y * newScale,
    };

    stage.position(newPos);
    performViewOptimisation(stage);
    updateGroupTitlesFontSize(stage);
    updateNodeStatusDisplayZoom(stage);
    // performZoomOptimisation(stage);
  }


  let debouncedScrollZoomHandler = debounce(scrollZoomHandler, 100, true);

  stage.on('wheel', scrollZoomHandler);


  stage.on('click', function () {
    props["on-stage-drag"] && props["on-stage-drag"]();
  });

  stage.on('dragmove', function () {
    performViewOptimisation(stage);
  })

  return stage;
}


function updateContents(stage, props) {

  var nodesLayer = new Konva.Layer({ name: "nodes" });

  // nodesLayer.on('click', function() {
  //
  //   props["on-stage-drag"]();
  // });


  let jobs = props.jobs || {};
  let jobsArray = Object.values(jobs);

  let subset = jobsArray//.slice(0, 300);

  let nodes = subset.map((n) => {
    let node = DAGnode({
      id: n.id,
      x: n.x,
      y: n.y,
      color: "green",
      name: n.name,
      node: n,
      props: props,
    });

    node.cache();

    return node;
  });


  // nodesLayer.listening(false)

  nodes.map(node => nodesLayer.add(node));


  let groups = props.groups || [];
  let groupNodes = []

  if (groups.length > 0 && groups[0].name != "root") {
    groupNodes = groups.map(group =>
      Group({
        x: group.x,
        y: group.y,
        width: group.width,
        height: group.height,
        id: group.id,
        name: group.name,
        transformGroup: group["transform-group"],
        "on-right-click": group["on-right-click"],
      }, stage));
  }


  var groupsLayer = new Konva.Layer({ name: "groups" })//.listening(false);
  groupNodes.map(gn => groupsLayer.add(gn));


  var connectionsLayer = new Konva.Layer({ name: "connections" }).listening(false);
  let connectionsGroup = new Konva.Group({ listening: false });

  connectionsLayer.add(connectionsGroup);

  let edges = Object.values(props.edges || {})//.slice(0, 100);

  let edgesWithPositions = edges.map(edge => {
    let startNode = jobs[edge["start-id"]];
    let endNode = jobs[edge["end-id"]];

    if (startNode && endNode) {
      return {
        id: edge.id,
        inCycle: edge["in-cycle?"],
        start: {
          x: startNode.x + nodeWidth,
          y: startNode.y + nodeHeight / 2,
          id: startNode.id
        },
        end: {
          x: endNode.x,
          y: endNode.y + nodeHeight / 2,
          id: endNode.id
        },
      };
    } else {
      return null;
    }
  }).filter(e => e);

  let connections = edgesWithPositions.map(e => Connection(e));

  connections.map(c => connectionsLayer.add(c));


  stage.add(groupsLayer);
  stage.add(connectionsLayer);
  stage.add(nodesLayer);
  groupsLayer.draw();
  connectionsLayer.draw();
  nodesLayer.draw();

  performViewOptimisation(stage);
  return stage;
}

function resizeDag(containerId, containerSize) {
  let cachedDag = dagCache[containerId];

  let dagStage = cachedDag.stage;

  dagStage.height(containerSize.height);
  dagStage.width(containerSize.width);

  return dagStage;
}

function reattachIfLinkBroken(containerId) {
  let cachedDag = dagCache[containerId];

  let dagStage = cachedDag.stage;

  let oldContainer = dagStage.container();

  var wrapper = document.getElementById(containerId).getBoundingClientRect();

  var width = wrapper.width;
  var height = wrapper.height;

  dagStage.container(containerId)

  dagStage.height(height);
  dagStage.width(width);

}


function renderDag(containerId, props, containerSize) {
  let cachedDag = dagCache[containerId];

  if (cachedDag) {
    if (!deepEqual(cachedDag.prevProps, props)) {

      // update preexisting dag

      let dagStage = cachedDag.stage;
      dagStage.destroyChildren();
      updateContents(dagStage, props);

      dagCache[containerId] = { stage: dagStage, prevProps: props };

      updateGroupTitlesFontSize(dagStage);
      updateNodeStatusDisplayZoom(dagStage);
    }

    cachedDag.stage.draw();


  } else {

    let dagStage = dag(containerId, props);
    updateContents(dagStage, props);

    updateGroupTitlesFontSize(dagStage);
    updateNodeStatusDisplayZoom(dagStage);

    dagCache[containerId] = { stage: dagStage, prevProps: props };
  }

  resizeDag(containerId, containerSize);
  reattachIfLinkBroken(containerId);
}

function deleteDag(containerId) {
  let cachedDag = dagCache[containerId];

  if (cachedDag) {
    cachedDag.stage.destroy();
    // delete dagCache[containerId];
  }
}

function getDagLayout(containerId) {
  const cachedDag = dagCache[containerId];
  const stage = cachedDag.stage;

  const nodes = stage.find(".node").reduce((acc, { attrs: { id, x, y } }) => {
    acc[id] = { x, y };
    return acc;
  }, {});

  const connections = stage.find(".edge").reduce((acc, { attrs: { id, points } }) => {
    acc[id] = { start: { x: points[0], y: points[1] }, end: { x: points[6], y: points[7] } };
    return acc;
  }, {});

  return {
    nodes: nodes,
    connections: connections
  };
}

function tween(containerId, tweenProps) {
  let cachedDag = dagCache[containerId];

  if (cachedDag) {
    cachedDag.stage.to(tweenProps);
  }
}

const zoomLevels = [1.6, 1, 0.4, 0.2, 0.1, 0.05, 0.02];

function zoom(containerId, direction) {
  let cachedDag = dagCache[containerId];

  if (cachedDag.stage) {
    let stage = cachedDag.stage;
    var oldScale = stage.scaleX();

    let availableZoomLevels = [];

    const width = stage.width();
    const height = stage.height();

    const diffX = width / 2;
    const diffY = height / 2;

    var origin = {
      x: (diffX - stage.x()) / oldScale,
      y: (diffY - stage.y()) / oldScale,
    };

    switch (direction) {
      case "in":
        if (oldScale >= zoomLevels[0]) {
          break;
        }

        availableZoomLevels = zoomLevels.filter(scale => scale > oldScale);

        if (availableZoomLevels.length > 0) {
          let newScale = availableZoomLevels[availableZoomLevels.length - 1];

          var newPos = {
            x: diffX - origin.x * newScale,
            y: diffY - origin.y * newScale,
          };

          stage.to({
            duration: 0.5,
            x: newPos.x,
            y: newPos.y,
            scaleX: newScale,
            scaleY: newScale,
            onFinish: () => {
              performViewOptimisation(stage);
              updateGroupTitlesFontSize(stage);
              updateNodeStatusDisplayZoom(stage);
            }
          });
        }

        break;

      case "out":
        if (oldScale <= zoomLevels[zoomLevels.length - 1]) {
          break;
        }

        availableZoomLevels = zoomLevels.filter(scale => scale < oldScale);

        if (availableZoomLevels.length > 0) {
          let newScale = availableZoomLevels[0];

          var newPos = {
            x: diffX - origin.x * newScale,
            y: diffY - origin.y * newScale,
          };

          stage.to({
            duration: 0.3,
            x: newPos.x,
            y: newPos.y,
            scaleX: newScale,
            scaleY: newScale,
            onFinish: () => {
              performViewOptimisation(stage);
              updateGroupTitlesFontSize(stage);
              updateNodeStatusDisplayZoom(stage);
            }
          });
        }

        break;

      default:
        console.warn("Unsupported zoom direction. Supported values: `in`, `out`.")
    }

    updateGroupTitlesFontSize(stage);

    // performZoomOptimisation(stage);
  }

}


var DAG = {
  dag: renderDag,
  deleteDag: deleteDag,
  getLayout: getDagLayout,
  tween: tween,
  zoom: zoom,
};


export default DAG;
